import { useRef, useState, ChangeEvent, MouseEvent, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosCAF from "../../components/Config/AxiosIni";
import Swal from "sweetalert2";
import { AxiosError } from 'axios';
import { Role } from './types';


interface UserData {
    nombre?: string;
    apellido?: string;
    fechanac?: string;
    usuario?: string;
    avatar?: string;
    perfil?:string;
    estado?:string;
}

export const useUserPage = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [image, setImage] = useState<File | null>(null);
    const [preview, setPreview] = useState<string | null>(null);
    const inputRefImg = useRef<HTMLInputElement>(null);
    const [userData, setUserData] = useState<UserData>({});
    const [tabSelect, setTabSelect] = useState<Role | null>(null);
    const [perfil, setPerfil] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingAvatar, setLoadingAvatar] = useState(true);
    



    const navigate = useNavigate();

    const handleAvatar = () => {
        alert("ariel gomez");
    };

    const inpinputFile = async () => {
        if (inputRefImg.current) {
        inputRefImg.current.value = "";
        inputRefImg.current.click();
        }
    };

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        navigate("/login");
        localStorage.clear();
    };

    const handleImageChange = async (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        setPreview(URL.createObjectURL(file));
        const token = localStorage.getItem("user") || "";

        const formData = new FormData();
        formData.append("imagen", file);
        formData.append("token", token);
        console.log("ariel-img",formData);

        try {
        const { data } = await axiosCAF.post("/auth/update", formData);
        console.log("ariel-data-imagen", data);

        if (data.tipoerror === "OK") {
            const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            },
            });
            Toast.fire({ icon: "success", title: "Se actualizó correctamente la imagen!!!" });
        }
        } catch (error: any) {
        console.error("ariel-error", error);
        if (error.response?.data?.tipoerror === "tokenexp") {
            Swal.fire({
            title: "Leer Atte.",
            text: error.response.data.message,
            icon: "error",
            confirmButtonColor: "#e31474",
            confirmButtonText: "Ok",
            }).then((result) => {
            if (result.isConfirmed) {
                handleLogout();
            }
            });
        }

        if (error.response?.data?.tipoerror === "noupdate") {
            const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            },
            });
            Toast.fire({
            icon: "error",
            title: "No se actualizó la imagen seleccionada, comuníquese con el administrador del sistema."
            });
        }
        }
    };

    const uploadUserData = async (token: string): Promise<void> => {   
        setLoading(true);
        try {
            const response = await axiosCAF.get('/auth/token', {
            headers: { Authorization: token },
            });    
            console.log('ariel-datos', response.data);
            setPerfil(response.data?.perfil);
            setUserData(response.data);
        } catch (error: unknown) {
            console.log('ariel-error', error);    
            const axiosError = error as AxiosError<any>;
            const tipoError = axiosError.response?.data?.tipoerror;

            switch (tipoError) {
            case 'tokenexp':
                Swal.fire({
                title: 'Error Leer Atte.',
                text: axiosError.response?.data?.message,
                icon: 'error',
                confirmButtonColor: '#e31474',
                confirmButtonText: 'Ok',
                }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/login');
                }
                });
                break;

                case 'NoRegistra':
                    Swal.fire({
                    title: 'Error Leer Atte.',
                    text: axiosError.response?.data?.message,
                    icon: 'error',
                    confirmButtonColor: '#e31474',
                    confirmButtonText: 'Ok',
                    }).then((result) => {
                    if (result.isConfirmed) {
                        navigate('/login');
                    }
                    });
                    break;
        
            case 'Network Error':
                Swal.fire(
                'Error Leer Atte.',
                'No se pudo conectar con el servidor. Verifica tu conexión a internet o intenta más tarde.',
                'error'
                );
                break;
        
            default:
                Swal.fire('Error Leer Atte.', axiosError.message, 'error');
                break;
            }
        }finally{
            setLoading(false);
        }
    };
  

    useEffect(() => {
    const token = localStorage.getItem('user');
    if(token){
        uploadUserData(token);
    }
    }, []);

    useEffect(() => {
        const src = preview || userData?.avatar;
        if (!src) return;

        const img = new Image();
        img.src = src;
        img.onload = () => setLoadingAvatar(false);
    }, [preview, userData?.avatar]);

    return {
        open,
        anchorEl,
        preview,
        inputRefImg,
        userData,
        tabSelect,
        perfil,
        loading,
        loadingAvatar,
        setLoadingAvatar,
        setTabSelect,
        inpinputFile,        
        setAnchorEl,
        handleAvatar,
        handleClick,
        handleClose,
        handleLogout,
        handleImageChange,
    };
};
